import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate' //Vuex 持久化存储
Vue.use(Vuex)
export default new Vuex.Store({
  // state --> 变量全面需要添加 $，要不然出现重复变量命名
  state: {
    tabItem: {},
    currentTabkey: {},
    message: '',
    token: null,
    userInfo: null,
    menuArr: []
  },
  mutations: {
    SET_TABS(state, _data) {
      state.tabItem = _data
    },
    SET_CURRENT_TAB(state, _data) {
      state.currentTabkey = _data
    },
    // 获取菜单内容
    SET_MENUARR_TAB(state, _data) {
      state.menuArr = _data
    },
    // 服务器消息
    SET_MESSAGE(state, _data) {
      state.message = _data;
    },
    //设置 Token
    SET_TOKEN(state, _Token) {
      state.token = _Token;
    },
    //清除用户
    CLEAR_USER_INFO(state) {
      state.userInfo = null;
    },
  },
  actions: {
    //清除登录数据
    CLEAR_TOKEN({ commit }) {
      commit('CLEAR_USER_INFO');
    },

  },
  modules: {},
  plugins: [
    //注册持久化存储插件
    createPersistedState({ storage: window.localStorage }),
  ],
})
